import { forwardRef, ForwardedRef, useContext } from 'react';
import GlobalContext from '~/context/giveaway/GlobalContext';
import {
  RBRLeadHeading,
  RBRDescription,
  CarvanaEmblemFinal,
  EmblemContainer
} from './Hero.styles';
import HeroLayout from './HeroLayout';

type Props = {};

const Hero = forwardRef<HTMLElement, Props>(function Hero(
  props,
  ref: ForwardedRef<HTMLElement>
) {
  const { giveawayIsLive } = useContext(GlobalContext);

  return (
    <section className="bg-white pb-[80px]" ref={ref} {...props}>
      <article id="hero-promo" className="relative">
        <HeroLayout />
      </article>
      <article
        id="hero-promo-partnership"
        className="m-auto flex flex-col items-center"
      >
        <div className="flex flex-col">
          <EmblemContainer>
            <div className="border-r-2 border-grey-2 s:pr-28 m:pr-32 l:pr-40">
              <CarvanaEmblemFinal />
            </div>
            <div />
            <div className="s:pl-20 m:pl-24 l:pl-28">
              <img
                className="h-56 m:h-64 l:h-80"
                src={`${process.env.CVNA_APP_CDN_URL}/home-assets/rbp/rbrEmblem.svg`}
                alt="Red Bull Rampage Logo"
              />
            </div>
          </EmblemContainer>
          <div className="flex content-center">
            <div className="text-center s:px-24 m:w-[523px] m:p-0 l:w-[680px]">
              <RBRLeadHeading>
                Carvana Goes Big <br className="m:hidden" /> at Red Bull Rampage
              </RBRLeadHeading>
              <RBRDescription>
                {giveawayIsLive
                  ? `We’re teaming up with Red Bull to stoke mountain freeride fans
                at Red Bull Rampage with an epic giveaway: the future of
                freeride, Jaxson Riddle’s custom bike. Scroll down to check it
                out and enter to win. Giveaway ends `
                  : `We teamed up with Red Bull to stoke mountain freeride fans
                at Red Bull Rampage with an epic giveaway: the future of
                freeride, Jaxson Riddle’s custom bike. Scroll down to check it
                out and enter to win. Giveaway ended `}
                <strong>Oct. 23, 2023 at 11:59pm ET</strong>.
              </RBRDescription>
            </div>
          </div>
        </div>
      </article>
    </section>
  );
});

export default Hero;
